/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.create.schedule.controllers', [
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences'
])

.controller('CouponsCreateScheduleController', ['$scope', '$state', '$q', 'ApiService', 'PermissionsService', 'CalendarService', function($scope, $state, $q, ApiService, PermissionsService, CalendarService) {

    $scope.couponsCreateSchedule = {

      model: {
        id: '',
        effectiveDates: []
      },

      next: 'application.coupons.list',

      init: function() {

        var title = {
          title: 'Edit Coupon Schedule',
          buttonLeft: {
            label: 'Cancel',
              action: function() {
              $state.go('application.coupons.list');
            }
          },
          buttonRight: {
            label: 'Save & Close',
            permissions: ['COUPONS_UPDATE'],
              action: function() {
              $scope.couponsCreateSchedule.complete(true);
            }
          }
        };

        $scope.$on("CouponsCreateController::save", this.onSave);

        $scope.$emit('Application::contentTitleChange', title);

        this.model.id = $state.params.couponId;
        this.getCouponEffectiveDates($state.params.couponId);
      },

      checkPermissions: function(permission){
        return PermissionsService.check(permission);
      },

      isValid: function() {
        var i, ii, self = $scope.couponsCreateSchedule, r = true;

        for (i=0,ii=self.model.effectiveDates.length;i<ii;i++) {
          if (!self.isValidDateRange(self.model.effectiveDates[i])) {
            r = false;
            break;
          }
        }

        return r;
      },

      isValidDateRange: function(dateRange) {
        var r = true;

        if ($scope.couponsCreateSchedule.isSubmitted) {
          r = (dateRange.effectiveEndDate && dateRange.effectiveStartDate && (new Date(dateRange.effectiveEndDate).getTime() - new Date(dateRange.effectiveStartDate).getTime()) > -1);
        }

        return r;
      },

      getCouponEffectiveDates: function(id) {
        ApiService.coupons.getEffectiveDates(id).then(this.success.getCouponEffectiveDates, this.error.getCouponEffectiveDates);
      },

      addEffectiveDates: function() {
        var self = $scope.couponsCreateSchedule;
        if (!self.model.effectiveDates) {
          self.model.effectiveDates = [];
        }
        self.model.effectiveDates.push({
          effectiveStartDate: '',
          effectiveEndDate: '',
          notes: ''
        });
      },

      complete: function(close) {
        var effectiveDates = $scope.couponsCreateSchedule.model.effectiveDates || [], updatePromises;
        this.isSubmitted = true;

        if (this.isValid()) {
          updatePromises = effectiveDates.map(function(effectiveDate) {
            var effectiveEndDate = (new Date(effectiveDate.effectiveEndDate)).setHours(23, 59, 59, 999),
              props = {
                couponId: $scope.couponsCreateSchedule.model.id,
                effectiveStartDate: effectiveDate.effectiveStartDate,
                effectiveEndDate: CalendarService.toISO8601(effectiveEndDate),
                notes: effectiveDate.notes
              };

            if (effectiveDate.id) {
              props.id = effectiveDate.id;
              if (effectiveDate.markedForDeletion) {
                return ApiService.coupons.effectiveDates.remove(props.id);
              }else{
                return ApiService.coupons.effectiveDates.update(props);
              }
            }else{
              return ApiService.coupons.effectiveDates.create(props);
            }
          });

          $q.all(updatePromises).then( $scope.couponsCreateSchedule.success.complete, $scope.couponsCreateSchedule.error.complete);
        }
      },

      removeEffectiveDate: function(index) {
        var effectiveDates = $scope.couponsCreateSchedule.model.effectiveDates, effectiveDate;
        if (effectiveDates && effectiveDates[index]) {
          effectiveDate = effectiveDates[index];
          if (effectiveDate.id) {
            effectiveDates[index].markedForDeletion = true;
          }else {
            effectiveDates.splice(index, 1);
          }
        }
      },

      process: function(dates) {
        var i, ii;

        for (i=0,ii=dates.length;i<ii;i++) {
          dates[i].effectiveEndDate = CalendarService.parseDate(dates[i].effectiveEndDate);
          dates[i].effectiveStartDate = CalendarService.parseDate(dates[i].effectiveStartDate);
        }

        return dates;
      },

      success: {
        init: function(response) {},

        getCouponEffectiveDates: function(response) {
          var self = $scope.couponsCreateSchedule;
          self.model.effectiveDates = self.process(response.data.payload);
        },

        complete: function(responses) {
          var self = $scope.couponsCreateSchedule;
          self.isSubmitted = false;
          $scope.$emit('CouponsCreateController::success', {
            message: 'Successfully Saved!'
          });

          $state.go(self.next, { couponId: $scope.couponsCreateSchedule.model.id });
        }
      },

      error: {
        init: function(response) {},

        getCouponEffectiveDates: function(response) {},

        complete: function(response) {
          $scope.couponsCreateSchedule.isSubmitted = false;
          $scope.$emit('CouponsCreateController::error', {
            message:  response.data.error
          });
        },

        createEffectiveDates: function(response) {
          $scope.$emit('CouponsCreateController::error', {
            message:  response.data.error
          });
        }
      },

      onSave: function(e, data) {
        var self = $scope.couponsCreateSchedule;
        self.next = data.state;
        self.complete(true);
      }

    };

    $scope.couponsCreateSchedule.init();

}])

  .controller('CouponDatePickerController', ['$scope', 'ConfigService', 'UserPreferencesService', '$timeout', function($scope, ConfigService, UserPreferencesService, $timeout) {
    $scope.couponDatePicker = {

      isOpen: false,

      dateOptions: {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
        showWeeks: false
      },
      
      isPreferenceLoaded: false,
      
      dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
      
      init: function() {
        this.today();
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[1];
        $scope.minDate = this.getMinDate();
        $scope.maxDate = this.getMaxDate();
        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
        $timeout(function () {
            $scope.couponDatePicker.isPreferenceLoaded = true;
        },0);
      },

      today: function() {
        this.dt = new Date();
      },

      clear: function () {
        $scope.dt = null;
      },

      getMinDate: function() {

        var d = new Date();

        d.setMonth(0);
        d.setDate(1);
        d.setFullYear(1900);

        return d;

      },

      getMaxDate: function() {

        var d = new Date();

        d.setMonth(11);
        d.setDate(31);
        d.setFullYear(d.getFullYear() + 100);

        return d;

      },

      open: function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.minDate = this.getMinDate();
        $scope.maxDate = this.getMaxDate();

        this.isOpen = true;
      },
      
      onDateFormatLoad: function (e, data) {
        var self = $scope.couponDatePicker;
        self.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
        self.dateOptions = {
          formatYear: 'yy',
          startingDay: 0,
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
        };
      }

    };

    $scope.couponDatePicker.init();
  }]);